module.exports = __webpack_public_path__ + "static/media/M1-22-Uldrak_Zul-cod131.ce5c1db4.png";